// Implements: F-UIX-010
/**
 * Every failure as the one shape the interface knows.
 *
 * An `ApiError` is returned untouched (its status and code are the point). A
 * thing that is not one - a bug, a rejected promise with a string - becomes an
 * `UNKNOWN` failure that keeps the cause as text, so a container never has to
 * branch on what a promise happened to reject with.
 */

import { ApiError, UNKNOWN_ERROR_CODE } from "./ApiError";

export function asApiError(cause: unknown): ApiError {
  if (cause instanceof ApiError) return cause;
  return new ApiError(0, UNKNOWN_ERROR_CODE, String(cause), new Headers());
}
